<template>
  <Transition name="modal-fade">
    <div class="filter-modal-overlay" v-if="visible" @click.self="skip">
      <div class="filter-modal" role="dialog" aria-modal="true" aria-labelledby="filter-modal-title">
        <h2 id="filter-modal-title">Match-Vorlieben</h2>
        <p>Möchtest du die Profile, die dir vorgeschlagen werden, nach Geschlecht oder Alter filtern? Das ist optional und kannst du jederzeit über das Filter-Symbol wieder ändern.</p>

        <div class="filter-field">
          <label>Geschlecht</label>
          <div class="option-group">
            <button
              v-for="g in genderOptions"
              :key="g.value"
              type="button"
              class="option-btn"
              :class="{active: gender === g.value}"
              @click="gender = g.value"
            >{{ g.label }}</button>
          </div>
        </div>

        <div class="filter-field">
          <label>Alter</label>
          <div class="age-range">
            <input type="number" min="12" max="120" v-model.number="ageMin" placeholder="von">
            <span>–</span>
            <input type="number" min="12" max="120" v-model.number="ageMax" placeholder="bis">
          </div>
        </div>

        <div class="filter-modal-actions">
          <button class="filter-apply-btn" @click="apply">Filter anwenden</button>
          <button class="filter-skip-btn" @click="skip">Überspringen</button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'FilterModal',
  emits: ['apply', 'skip'],
  data() {
    return {
      visible: false,
      gender: 'all',
      ageMin: null,
      ageMax: null,
      genderOptions: [
        {value: 'all', label: 'Alle'},
        {value: 'male', label: 'Männer'},
        {value: 'female', label: 'Frauen'}
      ]
    };
  },
  methods: {
    show(prefill) {
      if (prefill) {
        this.gender = prefill.gender || 'all';
        this.ageMin = prefill.age_min || null;
        this.ageMax = prefill.age_max || null;
      }
      this.visible = true;
    },
    apply() {
      this.visible = false;
      this.$emit('apply', {
        gender: this.gender,
        age_min: this.ageMin || null,
        age_max: this.ageMax || null
      });
    },
    skip() {
      this.visible = false;
      this.$emit('skip');
    }
  }
};
</script>

<style scoped>
.filter-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
  padding: 0 0 env(safe-area-inset-bottom, 0) 0;
}

.filter-modal {
  background: white;
  border-radius: 28px 28px 0 0;
  padding: 32px 28px 40px;
  width: 100%;
  max-width: 480px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  box-shadow: 0 -8px 40px rgba(0, 0, 0, 0.15);
  animation: slide-up 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-sizing: border-box;
}

@keyframes slide-up {
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

h2 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1D1D1F;
  margin: 0;
}

p {
  font-size: 0.9rem;
  color: #6E6E73;
  line-height: 1.5;
  margin: 0;
  max-width: 340px;
}

.filter-field {
  width: 100%;
  text-align: left;
}

.filter-field label {
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-secondary, #6E6E73);
  margin-bottom: 8px;
}

.option-group {
  display: flex;
  gap: 8px;
}

.option-btn {
  flex: 1;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid var(--border-color, #E5E5EA);
  background: #F5F5F7;
  color: #1D1D1F;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.15s ease;
}

.option-btn.active {
  background: var(--primary-color, #007AFF);
  border-color: var(--primary-color, #007AFF);
  color: white;
}

.age-range {
  display: flex;
  align-items: center;
  gap: 10px;
}

.age-range input {
  flex: 1;
  min-width: 0;
  background: #F5F5F7;
  border: 1px solid var(--border-color, #E5E5EA);
  border-radius: 12px;
  padding: 10px 14px;
  font-family: var(--font, inherit);
  font-size: 0.95rem;
  outline: none;
  box-sizing: border-box;
}

.age-range input:focus {
  background: white;
  border-color: var(--primary-color, #007AFF);
}

.age-range span {
  color: var(--text-secondary, #6E6E73);
  font-weight: 600;
}

.filter-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 8px;
}

.filter-apply-btn {
  width: 100%;
  padding: 16px;
  background: #007AFF;
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 700;
  font-family: var(--font, system-ui);
  cursor: pointer;
  min-height: 52px;
  transition: background 0.2s, transform 0.1s;
}

.filter-apply-btn:active {
  background: #0066d6;
  transform: scale(0.98);
}

.filter-skip-btn {
  width: 100%;
  padding: 14px;
  background: transparent;
  color: #6E6E73;
  border: none;
  border-radius: 14px;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: var(--font, system-ui);
  cursor: pointer;
  transition: color 0.2s;
}

.filter-skip-btn:active {
  color: #1D1D1F;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
